import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle3 } from 'components';
import { Helmet } from 'react-helmet';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalDeliveryAndReturnsEN extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'DeliveryAndReturns default title';
		const siteDescription = 'DeliveryAndReturns default description';
		const siteKeywords = 'DeliveryAndReturns default keywords';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/deliveryandreturns/en';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<InfoPageHeaderTitle>Delivery and Returns</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<InfoPageSection>
						<InfoPageTitle3>DELIVERY</InfoPageTitle3>
						<ul>
							<li>• How soon will I get my item?</li>
						</ul>
						<p>
							The expected delivery time depends on a range of factors – the delivery method that you have chosen or
							that your seller has provided, the item that is being delivered and so on.
						</p>
						<p>
							Essentially, expected delivery dates are generally provided by the seller under the shipping details
							section on the listing.
						</p>
						<p>
							Generally, national deliveries are faster when compared to international deliveries. Some sellers will
							also provide you with an option to track the delivery.
						</p>
						<ul>
							<li>• What shipping methods can I choose?</li>
						</ul>
						<p>
							Depending on the seller, you have a number of shipping methods to choose from. If a shipping method of
							your liking is unavailable, you can contact the seller and ask them to arrange an alternate shipping
							method for you.
						</p>
						<ul>
							<li>• Why can't I select a shipping option?</li>
						</ul>
						<p>
							If you are unavailable to select a shipping option, likely, the seller has not included it for your
							location.
						</p>
						<ul>
							<li>• Can I change my address and add a new one?</li>
						</ul>

						<p>
							Yes, you can change your address in a few simple steps. Login to your MARKETPLACE account and go to
							Account &gt; Settings &gt; Shipping. Here, click on Edit an existing address. Alternatively, you can also
							click on Add a New Address.
						</p>
						<ul>
							<li>• My item hasn't been delivered, what should I do?</li>
						</ul>
						<p>
							This doesn’t happen often. However, we recommend you to contact the seller directly to enquire about the
							status of your order. You can also ask them for tracking details to locate your order properly.
						</p>
						<p>
							However, if you don’t receive your order after a reasonable period of time, you can escalate the matter or
							write to us at ordersupport@marketplace.com .
						</p>
						<ul>
							<li>• Are there excess charges on items from international sellers? </li>
						</ul>
						<p>
							If you are an overseas buyer, your purchase could be subject to import duties and taxes which are imposed
							once the package reaches your country. You might also need to cover any additional customs clearance
							charges. We have no control over these charges and can’t predict how much they will be.
						</p>
						<p>
							To know more about the customs charges, it is highly recommended to check with a local customs office in
							your area. It is important to mention here that when you are ordering an item from a seller at
							MARKETPLACE, you are considered as the importer of the item. You must stick to the laws and regulations of
							the country in which you are receiving the goods.
						</p>
					</InfoPageSection>
					<InfoPageSection>
						<InfoPageTitle3>RETURNS</InfoPageTitle3>
						<p>
							You can cancel an order if it is not accepted by the seller yet. If you receive an item and want to return
							it for any reason whatsoever, you must write to the seller:
						</p>
						<ul>
							<li>• Within 14 days of receiving the item.</li>
							<li>
								• You may use the withdrawal form to let the Seller know if you wish to cancel your contract under the
								Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013.
							</li>
							<li>• Within 28 days if the item turns out to be faulty.</li>
						</ul>
						<p>
							You will be communicated on the instructions that you need to follow to return your item by the seller.
							Once the seller receives the returned item back, your refund will be processed to your original payment
							method.
						</p>
						<p>
							You need to ship the product at your expenses to the seller unless the item is incorrect or faulty, in
							which case the Seller will refund the return postage. If you cancel your contract under the Consumer
							Contracts (Information, Cancellation and Additional Charges) Regulations 2013 any standard shipping
							charges that you have paid to receive your purchase will be included as part of your refund.
						</p>
						<p>
							To ensure hassle-free returns, ensure that all the items that you wish to return are unworn, and in the
							original condition. They must contain all the tags.
						</p>
						<p>
							Also, ensure that you package the returned goods properly so that the seller receives them in a proper
							condition. If you have any further questions on returns, refunds or cancellations, please contact the
							seller.
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalDeliveryAndReturnsEN };
